import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import changestate from "../../context/action/user/changestate";
import Editusermodal from "./editusermodal";

const Userlist = () => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [user_id, setuser_id] = useState();
  const [user_name, setuser_name] = useState("");
  const [user_password, setuser_password] = useState("");
  const [user_role, setuser_role] = useState();
  const [show, setshow] = useState(false);

  return (
    <div>
      <Editusermodal
        show={show}
        setshow={setshow}
        user_id={user_id}
        user_name={user_name}
        setuser_name={setuser_name}
        user_password={user_password}
        setuser_password={setuser_password}
        user_role={user_role}
        setuser_role={setuser_role}
      />

      {/* User List Card */}
      <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
        {/* Section Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h2 className="text-base font-semibold text-slate-800">لیستی بەکارهێنەران</h2>
        </div>

        {/* Table */}
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-100">
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">ناو</th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">ڕۆڵ</th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">دۆخ</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {initState.user.map((lis) => (
              <tr
                key={lis.user_id}
                className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                onDoubleClick={() => {
                  setuser_id(lis.user_id);
                  setuser_name(lis.user_name);
                  setuser_role(lis.user_role);
                  setshow(true);
                }}
              >
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.user_name}
                </td>
                <td className="px-6 py-4 text-sm text-slate-500 text-right">
                  {lis.user_role}
                </td>
                <td 
                  className="px-6 py-4 text-right cursor-pointer"
                  onClick={() => {
                    changestate(lis.user_id, lis.user_state)(recaller)(
                      setrecaller
                    )(initDispatch)(clear);
                  }}
                >
                  <button
                    className={
                      lis.user_state == "active"
                        ? "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200 transition-colors cursor-pointer"
                        : "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-50 text-red-700 hover:bg-red-100 border border-red-200 transition-colors cursor-pointer"
                    }
                  >
                    {lis.user_state}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Userlist;
